import { call, put, takeLatest } from 'redux-saga/effects'

import { putPersonalInformation, patchUserPassword } from '@galo-monitor/services/apis/galoMonitorApi/resources/user'

import { UserActions, UserTypes } from './duckUser'

function* savePersonalInformation({ personalInformation, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(putPersonalInformation, personalInformation)
    yield call(onSuccess)
  } catch (err) {
    yield put(UserActions.userError(err.message))
    yield call(onError, err)
  }
}

function* updateUserPassword({ passwordData, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(patchUserPassword, passwordData)
    yield call(onSuccess)
  } catch (err) {
    yield put(UserActions.userError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(UserTypes.SAVE_PERSONAL_INFORMATION, savePersonalInformation),
  takeLatest(UserTypes.UPDATE_USER_PASSWORD, updateUserPassword)
]
